import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { MeetingPage } from '@/features/meetings/pages/meeting-page';

// The conversation of a channel's meeting, in the room's side panel (loaded when the panel opens).
const ConversationView = lazy(() =>
  import('@/features/chat/conversation-view').then((m) => ({ default: m.ConversationView })),
);

/**
 * The standalone room of a meeting or a call: no organisation in the address, so it serves the
 * links of the server's notices for everyone, a partner of a shared space included (a partner is
 * not a member of the host organisation and cannot open its `/o/{orgId}/…` pages). Full screen,
 * outside any shell. Authorization is the API's: the meeting is read, and the token issued, only
 * for a person allowed to join.
 */
export const Route = createFileRoute('/_auth/meetings/$meetingId')({
  component: StandaloneMeetingRoute,
});

function StandaloneMeetingRoute() {
  const { meetingId } = Route.useParams();
  return (
    <MeetingPage
      orgId={null}
      meetingId={meetingId}
      renderChat={(channelId) => (
        <Suspense fallback={null}>
          <ConversationView orgId={null} channelId={channelId} embedded />
        </Suspense>
      )}
    />
  );
}
